module.exports = __webpack_public_path__ + "img/factory-swiper-1.d5695519.png";